// client/src/components/layout/Alert.js
import React from 'react';
import ReactDOM from 'react-dom';
import { AlertCircle, CheckCircle, XCircle, Info, X } from 'lucide-react';
import useAlert from '../../hooks/useAlert'; // Novo hook

const alertConfig = {
    danger: { icon: XCircle, className: 'alert-danger' },
    error: { icon: XCircle, className: 'alert-danger' },
    success: { icon: CheckCircle, className: 'alert-success' },
    warning: { icon: AlertCircle, className: 'alert-warning' },
    info: { icon: Info, className: 'alert-info' }
};

const Alert = () => {
    const { alerts, removeAlert } = useAlert(); // Usando o novo hook

    if (!alerts || alerts.length === 0) {
        return null;
    }

    const alertContent = (
        <div className="alert-container">
            {alerts.map((alert) => {
                const { icon: Icon, className } = alertConfig[alert.type] || alertConfig.info;
                return (
                    <div key={alert.id} className={`alert-item ${className}`}>
                        <Icon className="alert-icon" size={20} />
                        <p className="alert-message">{alert.msg}</p>
                        <button onClick={() => removeAlert(alert.id)} className="alert-close-button" title="Fechar">
                            <X size={18} />
                        </button>
                    </div>
                );
            })}
        </div>
    );
    
    const portalRoot = document.getElementById('alert-root');
    if (!portalRoot) return null;

    return ReactDOM.createPortal(alertContent, portalRoot);
};

export default Alert;